const API_URL = "https://app.tavad.com/hce/wp-json";

export async function codepass(email,code,password) {
  const resetPass = {
    email,
    code,
    password,
  };
  try {
    const response = await fetch(`${API_URL}/bdpwr/v1/set-password`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(resetPass),
    } );
    const data = await response.json();

    console.log(data);
    return data;
  } catch (error) {
    console.error(error);
  }
}